var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41667 17.2292C3.95833 17.2292 3.56597 17.066 3.23958 16.7396C2.91319 16.4132 2.75 16.0208 2.75 15.5625V12.0625H4.41667V15.5625H15.5833V12.0625H17.2292V15.5625C17.2292 16.0208 17.066 16.4132 16.7396 16.7396C16.4132 17.066 16.0278 17.2292 15.5833 17.2292H4.41667ZM10 13.2292L5.5625 8.79167L6.75 7.625L9.16667 10.0625V2.5H10.8333V10.0625L13.25 7.625L14.4375 8.79167L10 13.2292Z",
    fill: "#646569"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridExport);
export default __webpack_public_path__ + "static/media/Grid_export.6ef28c470684353655a5e05140817420.svg";
export { ForwardRef as ReactComponent };